exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nhtml {\n  font-size: 100px;\n  -webkit-font-smoothing: antialiased;\n  height: 100%;\n  color: #404040;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  font-size: 0.14rem;\n  height: 100%;\n}\np,\ndiv,\nspan,\na,\nul,\nli {\n  margin: 0;\n  padding: 0;\n}\na,\nimg {\n  text-decoration: none;\n  outline: none;\n}\nimg {\n  border: none;\n}\n* {\n  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'SimSun', sans-serif;\n  box-sizing: border-box;\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.4s ease;\n}\n.fade-enter,\n.fade-leave-active {\n  opacity: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e015f16","scoped":false,"hasInlineConfig":false}!./~/postcss-loader/lib?sourceMap!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/App.vue
// module id = 596
// module chunks = 40